import {type ProjectTemplate} from '../initProject'

const blogTemplate: ProjectTemplate = {}

export default blogTemplate
